/**
 * Implements the provider search modal.
 */

import GenericModal from "../../generic/modal/base";
import Form from "./form";

const DEFAULTS = {
  title: "Find a Provider",
};

class ProviderSearch extends GenericModal {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  // @Override
  onRender() {
    this.body.show(new Form());

    // call superclass
    if (super.onRender) super.onRender();
  }
}

export { ProviderSearch as default };
